import * as React from 'react'
import createSvgIcon from './createSvgIcon'

export const ThumbsUp = createSvgIcon(
  <React.Fragment>
    <path
      d="M1 21h4V9H1v12zm22-11c0-1.1-.9-2-2-2h-6.31l.95-5.2.03-.32
             c0-.41-.17-.79-.44-1.06L14.17 1 7.59 7.59C7.21 7.95 7 8.45 7 9v10
             c0 1.1.9 2 2 2h9c.78 0 1.48-.45 1.84-1.13l3.02-6.03c.09-.18.14-.39.14-.6v-2z"
    />
  </React.Fragment>,
  'ThumbsUp'
)

export default ThumbsUp
